
<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn icon small fab fixed color="yellow darken-4" @click="copyLink">
          <v-icon dark color="white">mdi-share-variant</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-snackbar :timeout="timeout" color="yellow darken-4" v-model="snackbar">{{ msg }}</v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      snackbar: false,
      timeout: 3000,
      msg: "Link copiado.. Compartilhe com seus amigos!"
    };
  },
  methods: {
    copyLink() {
      var dummy = document.createElement("input"),
        text = window.location.href;
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.snackbar = true;
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {}
};
</script>

<style scoped>
</style>